export default __webpack_public_path__ + "static/media/linkedinBlack.aab89f2f.svg";